import { inject, Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';
import { ToastService } from '../_core/services/toast.service';

@Injectable()
export class DevicesGuard  {
  private readonly toastService = inject(ToastService);

  constructor(
    private configService: ConfigService,
    private router: Router,
    private authService: AuthService
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url.includes('/user/devices') || state.url.includes('logout') || !this.authService.isAuthenticated()) {
      return true;
    }
    if (this.configService.get().deviceControlViaWeb && this.configService.get().deviceLimitExceeded) {
      this.toastService.showToast('messages.devices.maximumExceeded', 'error');
      this.router.navigate(['/user/devices']);
      return false;
    }
    return true;
  }
}
